/**
 * [機種別商圏] 期間タイプ
 */
export const kiSyokenDateRanges = [
  {
    name: '前日',
    comparisonSection: ['前日', '前週同曜日'],
    defaultComparisonSection: '前週同曜日',
  },
  {
    name: '当日',
    comparisonSection: ['前日', '前週同曜日'],
    defaultComparisonSection: '前週同曜日',
  },
  {
    name: '前週',
    comparisonSection: ['前週', '平日/土日祝比較'],
    defaultComparisonSection: '前週',
  },
  {
    name: '今週',
    comparisonSection: ['前週', '平日/土日祝比較'],
    defaultComparisonSection: '前週',
  },
  {
    name: '前月',
    comparisonSection: ['前月', '前年同月', '平日/土日祝比較'],
    defaultComparisonSection: '前月',
  },
  {
    name: '今月',
    comparisonSection: ['前月', '前年同月', '平日/土日祝比較'],
    defaultComparisonSection: '前月',
  },
  {
    name: '過去7日',
    comparisonSection: ['過去7日', '平日/土日祝比較'],
    defaultComparisonSection: '過去7日',
  },
  {
    name: '過去14日',
    comparisonSection: ['過去14日', '平日/土日祝比較'],
    defaultComparisonSection: '過去14日',
  },
  {
    name: '過去28日',
    comparisonSection: ['過去28日', '平日/土日祝比較'],
    defaultComparisonSection: '過去28日',
  },
  {
    name: '過去xx日',
    comparisonSection: ['過去xx日', '平日/土日祝比較'],
    defaultComparisonSection: '過去xx日',
  },
  {
    name: 'カスタム',
    comparisonSection: ['カスタム', '平日/土日祝比較'],
    defaultComparisonSection: 'カスタム',
  },
] as const;

/**
 * [機種別商圏] 期間タイプ
 */
export const filteredKiSyokenDateRanges = [
  {
    name: '前日',
    comparisonSection: ['前日', '前週同曜日'],
    defaultComparisonSection: '前週同曜日',
  },
  {
    name: '当日',
    comparisonSection: ['前日', '前週同曜日'],
    defaultComparisonSection: '前週同曜日',
  },
  {
    name: '前週',
    comparisonSection: ['前週', '平日/土日祝比較'],
    defaultComparisonSection: '前週',
  },
  {
    name: '今週',
    comparisonSection: ['前週', '平日/土日祝比較'],
    defaultComparisonSection: '前週',
  },
  {
    name: '前月',
    comparisonSection: ['前月', '前年同月', '平日/土日祝比較'],
    defaultComparisonSection: '前月',
  },
  {
    name: '今月',
    comparisonSection: ['前月', '前年同月', '平日/土日祝比較'],
    defaultComparisonSection: '前月',
  },
  {
    name: '過去xx日',
    comparisonSection: ['過去xx日', '平日/土日祝比較'],
    defaultComparisonSection: '過去xx日',
  },
  {
    name: 'カスタム',
    comparisonSection: ['カスタム', '平日/土日祝比較'],
    defaultComparisonSection: 'カスタム',
  },
] as const;

/**
 * [機種別商圏] カレンダー内で使用される選択可能な期間単位の一覧
 */
export const kiSyokenDateUnits = [
  {
    name: '日',
    comparisonSection: ['前日', '前週同曜日', 'カスタム'],
    defaultComparisonSection: '前週同曜日',
  },
  {
    name: '週',
    comparisonSection: ['前週', 'カスタム', '平日/土日祝比較'],
    defaultComparisonSection: '前週',
  },
  {
    name: '月',
    comparisonSection: ['前月', '前年同月', 'カスタム', '平日/土日祝比較'],
    defaultComparisonSection: '前年同月',
  },
  {
    name: '範囲選択',
    comparisonSection: ['カスタム', '平日/土日祝比較'],
    defaultComparisonSection: 'カスタム',
  },
  {
    name: '自由選択',
    comparisonSection: ['カスタム', '平日/土日祝比較'],
    defaultComparisonSection: 'カスタム',
  },
] as const;
